export default __webpack_public_path__ + "static/media/jp.1a41692d.svg";